import { TranslationDTO } from './callback-on-callnote.model';
import { LocalizationTree } from './localization.model';
import { SipAccountOrderStartDate } from './sip-account-order.model';

/* Shapes copied from bookingmgmt `OutboxLinkOffer*` / `OutboxLinkOrderRequest`; the body token is the only credential. */

/** Offer link states, copied from `OutboxLinkOfferResponse.STATUS_*`. */
export const LINK_OFFER_STATUS_OPEN = 'OPEN';
/** The account already has a SIP number: the link's order is done. */
export const LINK_OFFER_STATUS_COMPLETED = 'COMPLETED';
/** The uid's validity ran out. Rendered like INVALID (BR5). */
export const LINK_OFFER_STATUS_EXPIRED = 'EXPIRED';
/** Unknown or tampered uid. Rendered like EXPIRED (BR5). */
export const LINK_OFFER_STATUS_INVALID = 'INVALID';
/** Valid link, but the order would fail on the contract data. */
export const LINK_OFFER_STATUS_MULTIPLE_PHONE_SERVICES = 'MULTIPLE_PHONE_SERVICES';
export const LINK_OFFER_STATUS_ADDRESS_INCOMPLETE = 'ADDRESS_INCOMPLETE';

/** Offer request timeout before the generic error page; same ceiling as `CHECK_TOKEN_TIMEOUT_MS`. */
export const LINK_OFFER_TIMEOUT_MS = 15_000;

/** `POST /bookingmgmt/v2/outbox/linkorders/offer` body. */
export interface LinkOrderOfferRequest {
	token: string;
}

/** `POST /bookingmgmt/v2/outbox/linkorders/offer` answer: 200 for every link state, nulls omitted. */
export interface LinkOrderOffer {
	/** One of the `LINK_OFFER_STATUS_*` constants. Anything else is treated as INVALID. */
	status: string;
	/** Monthly fee of the SIPTrunk extension; `0` is a real free offer. OPEN only. */
	monthlyPrice?: number | null;
	/** ISO-4217 code of `monthlyPrice`. OPEN only. */
	currency?: string | null;
	/** Company name of the contract address, so a wrong recipient notices. OPEN only, may be null. */
	companyName?: string | null;
	/** Brand of the customer. OPEN only. */
	brandId?: number | null;
	/** Language of the user account (1 de, 2 en, 3 it, 4 fr, 6 es, 9 nl). OPEN only. */
	languageId?: number | null;
	/** Localization tree of `connect`; may be absent for EXPIRED / INVALID. */
	translations?: TranslationDTO | null;
	/** The brand's `url` tree, reduced to the legal-document keys. OPEN only, may be `{}`. */
	legalLinks?: LocalizationTree | null;
}

/** `POST /bookingmgmt/v2/outbox/linkorders` body. Answered with `SipAccountOrderResponse`. */
export interface LinkOrderRequest {
	token: string;
	startDate: SipAccountOrderStartDate;
}
